import React from 'react';
import { IIconProps } from './utils';

export const CloudWithQuestionMark = ({
  fill = 'currentColor',
  height = 18,
  width = 18,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 18 18" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M12 14.25H12.791C14.8394 14.25 16.5 12.5764 16.5 10.5118C16.5 8.44727 14.8394 6.77362 12.791 6.77362H12.5947C12.105 5.02861 10.5132 3.75 8.625 3.75C6.34682 3.75 4.5 5.61137 4.5 7.90748C4.5 8.03488 4.50569 8.16095 4.51682 8.28543H4.45898C2.82478 8.28543 1.5 9.62065 1.5 11.2677C1.5 12.9148 2.82478 14.25 4.45898 14.25H9"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8.85027 11.247C9.26449 11.247 9.60027 11.5828 9.60027 11.997C9.60024 12.4112 9.26447 12.747 8.85027 12.747C8.43614 12.747 8.10031 12.4112 8.10027 11.997C8.10027 11.5829 8.43612 11.2471 8.85027 11.247ZM6.70184 7.12106C7.32403 6.04817 8.69893 5.68247 9.77313 6.29977C10.8492 6.91828 11.2204 8.29131 10.5973 9.36618C10.2863 9.90262 9.78534 10.2632 9.23113 10.4111C8.83112 10.5178 8.42014 10.2797 8.31317 9.87985C8.20648 9.4797 8.44429 9.0677 8.84442 8.96091C9.03156 8.9109 9.19645 8.7918 9.29949 8.61423C9.50455 8.26062 9.38379 7.80674 9.02508 7.60055C8.6645 7.39364 8.20482 7.5176 7.99871 7.87301C7.79092 8.23125 7.33258 8.35317 6.9743 8.14548C6.61613 7.93768 6.49419 7.47932 6.70184 7.12106Z"
      fill={fill}
    />
  </svg>
);
